import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    flex: 1,

    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',

    width: '100%',

    paddingTop: '3.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '2.5rem',
    paddingLeft: '1.5rem',

    backgroundColor: theme.colors.backgroundsSecondary,

    min1024: {
        overflow: 'auto',
        paddingRight: '2.5rem',
    },
});

export const header: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',

    minHeight: '2.5rem',
});

export const title: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
});

export const backButton: TRuleWithTheme = () => ({
    display: 'flex',

    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',

    transform: 'rotate(90deg)',
});

export const createButton: TRuleWithTheme = () => ({
    // The design draws a fixed 175x40 pill; the width comes from `min-width` so longer translations
    // can still grow the button.
    '&.ant-btn': {
        height: '2.5rem',
        minWidth: '10.9375rem',
    },

    '&.ant-btn.ant-btn-round': {
        borderRadius: '1.25rem',
    },
});
